import React, { useState, useEffect, useLayoutEffect } from "react";
import { getScrollTop } from "@/utils/common";
import { useHistory } from "react-router-dom";
import { connect } from "dva";
// import { simpleSpm } from '@/config/apiUrl'
import "./index.less";
import { useLocation } from 'react-router'
import ServiceModal from '@/components/ServiceModal'

import productBg from "../../assets/image/home/nav_cp_bg.png";
import productCapBg from "../../assets/image/home/nav_cp_cap_bg.png";
import productJzlBg from "../../assets/image/home/nav_cp_jzl_bg.png";
import productBqwBg from "../../assets/image/home/nav_cp_bqw_bg.png";

import planJrBg from "../../assets/image/home/nav_jj_jr_bg.png";
import planPlgdBg from "../../assets/image/home/nav_jj_plgd_bg.png";
import planRbBg from "../../assets/image/home/nav_jj_rb_bg.png";
import planZscqBg from "../../assets/image/home/nav_jj_zscq_bg.png";

//导航内容
const navLists = [
  { name: "首页", link: "/" },
  // {
  //   name: "产品中心",
  //   link: "/product",
  //   showImg: true,
  //   title: "数秦产品",
  //   desc: "打通数据全生命周期，全面释放数据价值",
  //   bgSrc: productBg,
  //   childrenW: "280px",
  //   childrenH: "120px",
  //   children: [
  //     {
  //       name: "CAP",
  //       desc: "可信数据服务基础支撑平台",
  //       link: "/product/cap",
  //       bgSrc: productCapBg,
  //     },
  //     {
  //       name: "金融综合服务链",
  //       desc: "全流程数据可信流通服务",
  //       link: "/product/jinzong",
  //       bgSrc: productJzlBg,
  //     },
  //     {
  //       name: "保全网",
  //       desc: "区块链电子数据证据专家",
  //       link: "/product/baoquan",
  //       bgSrc: productBqwBg,
  //     },
  //     { name: '保全网', link: '/product/baoquan',  },
  //     { name: '数融平台', link: '/product/dataplatform' },
  //     { name: '般枢平台', link: 'http://robanx.dataqin.com', out: true },
  //     { name: '氚平台', link: '/product/tritium' },
  //     { name: '不良资产', link: '/product/distressed' },
  //   ],
  // },
  // {
  //   name: "解决方案",
  //   link: "/solution",
  //   showImg: true,
  //   childrenW: "200px",
  //   childrenH: "92px",
  //   title: "赋能场景，跨域整合",
  //   desc: "数秦解决方案，针对行业特征及细分业务场景深度定制，一站式引领业务升级",
  //   bgSrc: productBg,
  //   children: [
  //     // { name: '数字藏品', link: '/solution/collection' },
  //     // { name: "溯源", link: "/solution/traceability" },
  //     // { name: '溯源', link: 'https://shunong.shuqinkeji.com/#/fornt/solution/suyuans', out: true },
  //     { name: "数据金融", link: "/solution/finance", bgSrc: planJrBg },
  //     { name: "数据资产入表", link: "/solution/dataAssets", bgSrc: planRbBg },
  //     { name: "知识产权保护", link: "/solution/propertyRight", bgSrc: planZscqBg },
  //     {
  //       name: "批量个贷商事调解",
  //       link: "/solution/mediation",
  //       bgSrc: planPlgdBg,
  //     },
  //     // { name: '医疗', link: '/solution/medical' },
  //     // { name: '数字农业', link: 'https://shunong.shuqinkeji.com/#/fornt/home', out: true },
  //     // { name: '知识产权', link: '/solution/propertyRight' },
  //     // { name: '政务', link: '/solution/government' },
  //     // { name: '司法', link: '/solution/judicial' },
  //     // { name: '碳中和', link: 'https://shunong.shuqinkeji.com/#/fornt/solution/carbon', out: true },
  //   ],
  // },
  { name: "核心能力", link: "/coreCompetencies" },
  {
    name: "行业应用",
    link: "/industryApplications",
    children: [
      { name: "数字金融", link: "/industryApplications/jinzong" },
      { name: "数据资产", link: "/industryApplications/dataAssets" },
      { name: "数字司法", link: "/industryApplications/digitalJustice" },
      { name: "商事调解", link: "/industryApplications/mediation" },
      { name: "数字护照", link: "/industryApplications/digitalPassport" },
      { name: "智能资产", link: "/industryApplications/digitalAssets" },
    ],
  },
  {
    name: "技术成果",
    link: "/achievements",
    children: [
      { name: "研究院", link: "/achievements/academy" },
      { name: "氚链", link: "/achievements/hybridchain" },
    ],
  },
  { name: "实时资讯", link: "/news" },
  {
    name: "关于",
    link: "/about",
    children: [
      { name: "公司介绍", link: "/about" },
      { name: "团队风采", link: "/about/team" },
      { name: "企业荣誉", link: "/about/honor" },
      { name: "加入我们", link: "/about/join" },
    ],
  },
];

let title = null;

function Navigation(props) {
  let _props = props;
  const [activeLink, setActiveLink] = useState("/");
  const [isShowsearch, setSearch] = useState(false);
  const [blackHeader, setBlackHeader] = useState(true);
  const [searchbox, setSearchbox] = useState(false);
  const [isScroll, setScroll] = useState(false);
  const [ishover, setActive] = useState("");
  const [ref, setRef] = useState(null);
  const [edit, setEdit] = useState(false);
  const history = useHistory();

  const { theme } = props

  const location = useLocation()
  useLayoutEffect(() => {
    document.body.setAttribute('theme', theme)
  }, [location.pathname])

  function handleScroll() {
    getScrollTop().then((top) => {
      if (top <= 0) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    });
  }

  function handleSearch(e) {
    _props.dispatch({
      type: "news/searchNews",
      payload: { title: e.target.value },
    });
  }
  // 开始操作搜索
  function handlestart() {
    _props.dispatch({ type: "news/removeSearchList", payload: [] });
    setSearchbox(true);
    setEdit(true);
  }
  // 点击拉取列表
  function handleGetNews(title) {
    //  开始拉去
    // 跳转到详情页面
    _props.dispatch({ type: "news/setNewTitle", payload: { title: title } });
    setSearchbox(true);
    _props.dispatch({
      type: "news/getNewList",
      payload: { title: title, hot: 0 },
    });
  }
  function handleGoDetail(item) {
    if (item && item.id) {
      history.push(`/newDetail/${item.id}`);
    }
  }

  useEffect(() => {
    if (edit && ref) {
      ref.focus();
    }
  });

  useEffect(() => {
    _props.dispatch({ type: "news/setNewTitle", payload: { title: "" } });
    window.addEventListener("scroll", handleScroll);
    setActiveLink(window.location.pathname);
    // 目前没有做子路由，所以先暂时这样处理
    if (window.location.pathname.indexOf("/newDetail") > -1) {
      setActiveLink("/news");
    }
    if (window.location.pathname.indexOf("/news") > -1) {
      setSearch(true);
    }
  }, []);

  const logoImg = theme === 'dark' ? require('../../assets/image/logo_black@2x.png') : require("../../assets/img/home/logo-dq-black.png")

  function goLink(link = "/", out) {
    if (out) {
      window.open(link);
    } else {
      history.push(link);
      getScrollTop(0);
    }
  }
  // 监听路由变化

  const isActive = (link) =>
    link === "/" ? activeLink === link : activeLink.includes(link);
  return (
    <header
      className={`header ${theme}`}
    >
      <div className="header-box">
        <div className="header-left">
          <img
            onClick={() => goLink("/")}
            className="logo"
            src={logoImg}
            alt="数秦科技"
          />
        </div>
        <div className="nav-lists">
          {navLists.map((nav) => (
            <React.Fragment key={nav.name}>
              {Array.isArray(nav.children) ? (
                <div
                  key={nav.name}
                  className={`nav-second ${
                    nav.link === "/" ? "hoverWhite" : ""
                  } ${!nav.showImg ? "nav-expand" : ""}`}

                  onMouseLeave={() => {
                    setActive('')
                  }}
                >
                  <span
                    className={isActive(nav.link) ? "active" : ""}
                    onMouseEnter={() => {
                      setActive(nav.link);
                    }}
                    // onMouseLeave={() => {
                    //   setActive('')
                    // }}
                  >
                    {nav.name}
                    <svg className="icon" aria-hidden="true">
                      <use href="#icon-jiantou" />
                    </svg>
                  </span>
                  {nav.showImg ? (
                    <div
                      className={`expand-block ${
                        ishover === nav.link
                          ? "select-block-active"
                          : "select-block-none"
                      }`}
                      onMouseLeave={() => {
                        setActive("");
                      }}
                    >
                      <div
                        className="expand-block-left"
                        style={{ backgroundImage: `url(${nav.bgSrc})` }}
                      >
                        <p>{nav.title}</p>
                        <div>{nav.desc}</div>
                      </div>
                      <div className="expand-block-right">
                        <h4>{nav.name}</h4>
                        <div style={{ display: "flex" }}>
                          {nav.children.map((item) => (
                            <div
                              className="expand-block-right-item"
                              key={item.name}
                              onClick={() => goLink(item.link, item.out)}
                              style={{
                                backgroundImage: `url(${item.bgSrc})`,
                                width: nav.childrenW,
                                height: nav.childrenH,
                              }}
                            >
                              <p>{item.name}</p>
                              <span>{item.desc}</span>
                              <img
                                src={require("../../assets/image/home/arrow.png")}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`select-block ${
                        ishover === nav.link
                          ? "select-block-active"
                          : "select-block-none"
                      }`}
                      onMouseLeave={() => {
                        setActive("");
                      }}
                    >
                      {nav.children.map((item) => (
                        <a
                          key={item.name}
                          onClick={() => goLink(item.link, item.out)}
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div className="nav-second">
                  <span
                    onClick={() => goLink(nav.link, nav.out)}
                    className={isActive(nav.link) ? "active" : ""}
                  >
                    {nav.name}
                  </span>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        <div style={{ flex: 1 }}>
          {
            isShowsearch && 
            <div className="header-search" style={{ minWidth: '200px' }}>
              <div className="header-search-divider" />
              <div className="header-search-box">
                <img
                  src={require("../../assets/image/news/news_icon_ss@2x.png")}
                />
                <input
                  placeholder="搜索..."
                  onClick={() => {
                    handlestart();
                  }}
                />
              </div>
            </div>
          }
          {
            searchbox && 
            <div className="search-box">
              <div className="search-box-content">
                <img
                  src={require("../../assets/image/news/news_icon_x@2x.png")}
                  onClick={() => setSearchbox(false)}
                  className="search-box-content-close"
                />
                <div className="search">
                  <input
                    ref={(el) => setRef(el)}
                    placeholder="搜索..."
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        handleGetNews(e.target.value);
                        setSearchbox(false);
                        getScrollTop(0);
                      }
                    }}
                    onChange={(e) => {
                      handleSearch(e);
                      title = e.target.value;
                      // 去拉去匹配的列表
                    }}
                  />
                  <img
                    src={require("../../assets/image/news/news_icon_ss_2@2x.png")}
                    className="search-icon"
                    onClick={() => {
                      // 开始去后台搜索数据
                      handleGetNews(title);
                      // 左侧栏目变化
                      setSearchbox(false);
                    }}
                  />
                </div>
                <ul>
                  {props.searchList &&
                    props.searchList.map((item) => (
                      <li
                        key={item.id}
                        onClick={() => {
                          // 获取详情
                          handleGoDetail(item);
                        }}
                      >
                        <p>{item.title}</p>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          }
        </div>
        <div className="header-contact">
          <div className="header-tel">
            <img src={theme === 'dark' ? require("../../assets/image/n_tel_w@2x.png") : require("../../assets/image/home/tel.png")} />
            0571-87292902
          </div>
          <ServiceModal>
            <div className="commom-btn-blue">申请试用</div>
          </ServiceModal>
        </div>
      </div>
    </header>
  );
}

const mapStateToProps = (state) => ({
  searchList: state.news.searchList,
});
export default connect(mapStateToProps)(Navigation);
